class PaymentConnectController {
  constructor(paymentConnectService) {
    this.paymentConnectService = paymentConnectService;
    this.endpoint = '/api/payment/connect';
  }

  $onInit () {
    return this.paymentConnectService.connect(this.code, this.id, this.endpoint)
      .then(() => {
        this.response = 'Your account has been successfully connected';
      })
      .catch(() => {
        this.error = true;
        this.response = 'Your account could not be connected, please try again';
      });
  }
}

PaymentConnectController.$inject = [ 'paymentConnectService' ];

export default PaymentConnectController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/controllers/payment.connect.controller.js